import React, { Component, Fragment } from "react";
import { Tabs, Select, Form, Button, message, Divider } from "antd";
import styles from "../index.module.less";
import TheBestSpinner from "./TheBestSpinner";
import SpinRewriter from "./SpinRewritter";
import WordAI from "./WordAI";
import LatinSpinner from "./LatinSpinner";
import SpinnerComBr from "./SpinnerComBr";
import { inject, observer } from "mobx-react";
import { testSpinArticle } from "services/options";
import co from "co";

const TabPane = Tabs.TabPane;
const Option = Select.Option;
const FormItem = Form.Item;

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 3 }
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 21 }
	}
};

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class SpinnerForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}	

	render() {
		let spinnerInfo = "";
		switch (this.props.selectedSpinner) {
			case "TheBestSpinner":
				spinnerInfo = <TheBestSpinner form={this.props.form} />;
				break;
			case "SpinRewriter":
				spinnerInfo = <SpinRewriter form={this.props.form} />;
				break;
			case "WordAI":
				spinnerInfo = <WordAI form={this.props.form} />;
				break;
			case "ESpinner":
				spinnerInfo = (
					<LatinSpinner
						form={this.props.form}
						emailAddressField="eSpinner.email"
						apiKeyField="eSpinner.apiKey"
					/>
				);
				break;
			case "Spinea":
				spinnerInfo = (
					<LatinSpinner
						form={this.props.form}
						emailAddressField="spinea.email"
						apiKeyField="spinea.apiKey"
					/>
				);
				break;
			case "SpinnerBR":
				spinnerInfo = (
					<LatinSpinner
						form={this.props.form}
						emailAddressField="spinnerBR.username"
						apiKeyField="spinnerBR.apiKey"
						username={true}
					/>
				);
				break;
			case "SpinnerComBr":
				spinnerInfo = <SpinnerComBr form={this.props.form} />;
				break;
		}
		const checkValidityButton = (
			<Button
				type="primary"
				loading={this.props.checkingSpinnerService}
				onClick={this.props.checkValidity}
			>
				{this.props.checkingSpinnerService ? "Checking" : "Check"}
			</Button>
		);

		const resultText = <span><b>Result:</b> {this.props.result}</span>;
		return (
			<Fragment>
				<Form className={styles.rxform}>
					<FormItem label="Spinner service">
							<Select style={{ width: 200 }} value={this.props.selectedSpinner} onChange={this.props.spinnerChanged}>
								<Option value="BuiltInSpinner">Built-in Spinner</Option>
								<Option value="TheBestSpinner">thebestspinner.com</Option>
								<Option value="SpinRewriter">spinrewriter.com</Option>
								<Option value="WordAI">wordai.com</Option>
								<Option value="ESpinner">espinner.net</Option>
								<Option value="Spinea">Spinea</Option>
								<Option value="SpinnerBR">spinnerbr.com</Option>
								<Option value="SpinnerComBr">spinner.com.br</Option>
							</Select>
					</FormItem>
				</Form>
				{spinnerInfo}
				{checkValidityButton}
				<Divider type="horizontal" />
				{resultText}
			</Fragment>
		);
	}
}

@inject("rootStore")
@observer
class SpinnerTab extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			selectedSpinner: "TheBestSpinner",
			checkingSpinnerService: false,
			result: "_"
		}
	}

	checkValidity = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		const options = optionsStore.stateForm;

		const spinnerService = this.state.selectedSpinner;

		let params = "";

		switch (spinnerService) {
			case "TheBestSpinner":
				params = {
					username: options.tbs.username.value,
					password: options.tbs.password.value
				};
				break;
			case "BuiltInSpinner":
				params = {
					username: "",
					password: ""
				};
				break;
			case "SpinRewriter":
				params = {
					username: options.spinRewriter.email.value,
					password: options.spinRewriter.apiKey.value
				};
				break;
			case "WordAI":
				params = {
					username: options.wordAi.email.value,
					password: options.wordAi.password.value
				};
				break;
			case "ESpinner":
				params = {
					username: options.eSpinner.email.value,
					password: options.eSpinner.apiKey.value
				};
				break;
			case "Spinea":
				params = {
					username: options.spinea.email.value,
					password: options.spinea.apiKey.value
				};
				break;
			case "SpinnerBR":
				params = {
					username: options.spinnerBR.username.value,
					password: options.spinnerBR.apiKey.value
				};
				break;
			case "SpinnerComBr":
				params = {
					username: "",
					password: options.spinnerComBr.apiKey.value
				};
				break;
		}

		params.spinnerService = spinnerService;
		params.body = "This is a test sentence";

		co(
			function*() {
				this.setState({
					checkingSpinnerService: true
				});
				const response = yield testSpinArticle(params);
				this.setState({
					checkingSpinnerService: false
				});
				if (response == null) {
					message.error("Failed to test the spinner service. Unknown error", 3);
					return;
				}
				if (response.error) {
					message.error("Error: " + response.error.message, 3);
					return;
				}
				this.setState({
					result: response.result
				});
			}.bind(this)
		);
	};

	spinnerChanged = (value) => {
		this.setState({
			selectedSpinner: value,
			result: "_"
		})
	}

	onFieldsChange = changedFields => {
		const {
			rootStore: { optionsStore }
		} = this.props;
		optionsStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		const options = optionsStore.stateForm;

		return {			
			tbs: {
				username: Form.createFormField(options.tbs.username),
				password: Form.createFormField(options.tbs.password),
				maxSyns: Form.createFormField(options.tbs.maxSyns),
				quality: Form.createFormField(options.tbs.quality)
			},
			spinRewriter: {
				email: Form.createFormField(options.spinRewriter.email),
				apiKey: Form.createFormField(options.spinRewriter.apiKey),
				confidenceLevel: Form.createFormField(
					options.spinRewriter.confidenceLevel
				),
				protectedTerms: Form.createFormField(
					options.spinRewriter.protectedTerms
				),
				nestedSpintax: Form.createFormField(options.spinRewriter.nestedSpintax),
				paragraphs: Form.createFormField(options.spinRewriter.paragraphs),
				newParagraphs: Form.createFormField(options.spinRewriter.newParagraphs),
				sentences: Form.createFormField(options.spinRewriter.sentences),
				sentenceTrees: Form.createFormField(options.spinRewriter.sentenceTrees)
			},
			wordAi: {
				email: Form.createFormField(options.wordAi.email),
				password: Form.createFormField(options.wordAi.password),
				quality: Form.createFormField(options.wordAi.quality),
				nonested: Form.createFormField(options.wordAi.nonested),
				sentence: Form.createFormField(options.wordAi.sentence),
				paragraph: Form.createFormField(options.wordAi.paragraph)
			},
			eSpinner: {
				email: Form.createFormField(options.eSpinner.email),
				apiKey: Form.createFormField(options.eSpinner.apiKey)
			},
			spinea: {
				email: Form.createFormField(options.spinea.email),
				apiKey: Form.createFormField(options.spinea.apiKey)
			},
			spinnerBR: {
				username: Form.createFormField(options.spinnerBR.username),
				apiKey: Form.createFormField(options.spinnerBR.apiKey)
			},
			spinnerComBr: {
				apiKey: Form.createFormField(options.spinnerComBr.apiKey)
			}
		};
	};

	render() {
		return (
			<SpinnerForm
				fields={this.mapPropsToFields()}
				onFieldsChange={this.onFieldsChange}
				selectedSpinner={this.state.selectedSpinner}
				checkingSpinnerService={this.state.checkingSpinnerService}
				result={this.state.result}
				checkValidity={this.checkValidity}
				spinnerChanged={this.spinnerChanged}
			/>
		);
	}
}

export default SpinnerTab;
